import React from 'react';
import "./About.css";
import images from '../../assets/images/papt.png'

const About = () => {
  return (
    <section className='about section-p bg-dark' id = "about">
        <div className='container'>
            <div className='about-content grid text-center'>
                <div className = "content-left">
                    <img src = {images} alt = "" />
                </div>
                <div className='content-right'>
                    <div className='section-t'>
                        <h3>About Us</h3>
                    </div>
                    <p className = "text">We introduce ‘Network paper’ which is a program to reduce paper consumption of ICCR, while reducing time and effort wasted on managing physical files, increasing their longevity by making it all digital in a secure and authenticated or verified manner using Blockchain technology.</p>
                    <p className='text'>It will make the data management much authorized and data with increased traceability</p>
                </div>
            </div>
        </div>
    </section>
  )
}

export default About